import * as React from 'react';
import { OnSale } from '../OnSale/OnSale';

export interface IProfileOwnedProps {
}

export function ProfileOwned(props: IProfileOwnedProps) {


    return (
        <div>
            <OnSale />
        </div>
    );
}
